import { render, staticRenderFns } from "./music.vue?vue&type=template&id=45eaa760&scoped=true&"
import script from "./music.vue?vue&type=script&lang=js&"
export * from "./music.vue?vue&type=script&lang=js&"
import style0 from "./music.vue?vue&type=style&index=0&id=45eaa760&prod&lang=less&"
import style1 from "./music.vue?vue&type=style&index=1&id=45eaa760&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eaa760",
  null
  
)

export default component.exports